// src/utils/api.js
import axios from 'axios'

const baseURL = process.env.VUE_APP_API_BASE

const api = axios.create({
  baseURL, // 例如：http://192.168.31.177:5001/api/
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})



// ✅ 可選：自動加入 token（若你有登入功能）
/*
import { useAuthStore } from '@/stores/useAuthStore'

api.interceptors.request.use(config => {
  const authStore = useAuthStore()
  if (authStore.user?.tokenStr) {
    config.headers.Authorization = `Bearer ${authStore.user.tokenStr}`
  }
  return config
})
*/

export default api